'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _chemist = require('chemist');

var _FormInput = require('../../../FormInput');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _react.PropTypes.func;
var AddressBookAdd = (_dec = (0, _reactRedux.connect)(function (state) {
  return { postcodeError: state.addressBook.postcodeError };
}), _dec2 = (0, _reactI18next.translate)(), _dec3 = (0, _chemist.configurable)(), _dec4 = (0, _reactCssModules2.default)(_style2.default), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(AddressBookAdd, _React$Component);

  function AddressBookAdd() {
    (0, _classCallCheck3.default)(this, AddressBookAdd);
    return (0, _possibleConstructorReturn3.default)(this, (AddressBookAdd.__proto__ || (0, _getPrototypeOf2.default)(AddressBookAdd)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddressBookAdd, [{
    key: 'formErrors',
    value: function formErrors() {
      if (this.props.postcodeError) {
        return { AddressBookPostcode: ['is invalid'] };
      }

      return {};
    }
  }, {
    key: 'renderCompanyField',
    value: function renderCompanyField() {
      var t = this.props.t;


      return _react2.default.createElement(
        _FormInput.Field,
        { inputName: 'AddressBookCompany', inputLabel: t('spree.company') },
        _react2.default.createElement(_FormInput.Input, { name: 'AddressBookCompany' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          config = _props.config;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h1',
          null,
          'Add new address'
        ),
        _react2.default.createElement(
          _FormInput.Fieldset,
          null,
          config.theme === 'painters' && this.renderCompanyField(),
          _react2.default.createElement(
            _FormInput.Field,
            { inputName: 'AddressBookFirstName', inputLabel: t('spree.first_name'), fieldRequired: true },
            _react2.default.createElement(_FormInput.Input, { name: 'AddressBookFirstName', required: true })
          ),
          _react2.default.createElement(
            _FormInput.Field,
            { inputName: 'AddressBookLastName', inputLabel: t('spree.last_name'), fieldRequired: true },
            _react2.default.createElement(_FormInput.Input, { name: 'AddressBookLastName', required: true })
          ),
          _react2.default.createElement(
            _FormInput.Field,
            { inputName: 'AddressBookAddressLine1', inputLabel: t('spree.address1'), fieldRequired: true },
            _react2.default.createElement(_FormInput.Input, { name: 'AddressBookAddressLine1', required: true })
          ),
          _react2.default.createElement(
            _FormInput.Field,
            { inputName: 'AddressBookAddressLine2', inputLabel: t('spree.address2') },
            _react2.default.createElement(_FormInput.Input, { name: 'AddressBookAddressLine2' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-sm-6' },
              _react2.default.createElement(
                _FormInput.Field,
                { inputName: 'AddressBookCity', inputLabel: t('spree.city'), fieldRequired: true },
                _react2.default.createElement(_FormInput.Input, { name: 'AddressBookCity', required: true })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-sm-6' },
              _react2.default.createElement(
                _FormInput.Field,
                {
                  inputName: 'AddressBookPostcode',
                  errors: this.formErrors(),
                  inputLabel: t('spree.zipcode'),
                  fieldRequired: true
                },
                _react2.default.createElement(_FormInput.Input, { name: 'AddressBookPostcode', required: true })
              )
            )
          ),
          _react2.default.createElement(
            _FormInput.Field,
            { inputName: 'AddressBookState', inputLabel: t('spree.state'), fieldRequired: true },
            _react2.default.createElement(_FormInput.Input, { name: 'AddressBookState', required: true })
          ),
          _react2.default.createElement(
            _FormInput.Field,
            { inputName: 'AddressBookPhone', inputLabel: t('spree.phone'), fieldRequired: true },
            _react2.default.createElement(_FormInput.Input, {
              name: 'AddressBookPhone',
              placeholder: 'Digits only e.g 0044123456789',
              required: true,
              type: 'tel',
              pattern: '^[\\d\\s]+$'
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'button-bar' },
          _react2.default.createElement(
            _FormInput.Button,
            {
              type: 'button',
              styleName: 'button-cancel',
              weight: 'quaternary',
              onClick: this.props.onCancel
            },
            'Cancel'
          ),
          _react2.default.createElement(
            _FormInput.Button,
            { type: 'submit', styleName: 'button-select' },
            'Save'
          )
        )
      );
    }
  }]);
  return AddressBookAdd;
}(_react2.default.Component), _class2.propTypes = {
  onCancel: func.isRequired
}, _temp)) || _class) || _class) || _class) || _class);
exports.default = AddressBookAdd;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressBook/components/AddressBookAdd/index.js
// module id = 2254
// module chunks = 0